export default "__VITE_ASSET__qyzQGq$H__"